const gitBranch = __GITBRANCH__;
const gitCommit = __GITCOMMIT__;
const appVersion = __APP_VERSION__;
const photoVideoFavoriteLimit = __PHOTO_VIDEO_FAVORITE_LIMIT__;
const facebookApiId = __FACEBOOK_API_ID__;

export { gitBranch, gitCommit, appVersion };
export { photoVideoFavoriteLimit };
export { facebookApiId };
